// eslint-disable-next-line import/prefer-default-export
export function getRandomValue() {
  return Math.floor(Math.random() * 99999999);
}

/**
 * Read the subject claim off the stored Okta access token.
 *
 * The submissions API compares `senderEmail` against this exact claim and
 * rejects the request when they differ, so the token is the authority on who
 * the sender is -- not the OpenID `email` claim or the `/userinfo` response,
 * which are not guaranteed to carry the same address.
 *
 * @returns {string} the `sub` claim, or '' when it cannot be read
 */
export function getTokenSubject() {
  const token = window.sessionStorage.accessToken;
  if (!token) return '';

  try {
    const payload = String(token).split('.')[1];
    if (!payload) return '';
    const claims = JSON.parse(window.atob(payload)) || {};
    return typeof claims.sub === 'string' ? claims.sub.trim() : '';
  } catch (e) {
    // Malformed token - fall back to the caller's own value.
    return '';
  }
}



// WEBPACK FOOTER //
// ./src/lib/auth.utils.js